export default __webpack_public_path__ + "static/ProValue_5-297a24f1961737a945322dff44dcff52.webp";